import React, { useState, useEffect, Fragment, useRef } from 'react';
import groupService from '../../../Group/services';
import service from '../service';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import { DayWiseEmployeeCheckRollTable } from "../../../Common/Table/tableContent";
import MenuItem from '@material-ui/core/MenuItem';
import { Pagination, PageHeader, paginate } from '../../../../Common';
import Joi from '@hapi/joi';
import { validateProperty, validate } from "../../../Common";
import { Grid } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import FormHelperText from '@material-ui/core/FormHelperText';
import "react-datepicker/dist/react-datepicker.css";
import { EmployeeCheckRollDayWiseMonthlyDetailReportSchema } from "../EmployeeCheckRollDayWiseMonthlyDetailReportSchema";
import { LoadingSpinerComponent } from '../../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../Common/services';
import tokenService from '../../../../Common/tokenDecoder';
import '../../../Common/Table/table.css';
import TablePagination from '@material-ui/core/TablePagination';
import Chip from '@material-ui/core/Chip';
import moment from 'moment';
import xlsx from 'json-as-xlsx';
import CreatePDF from './createPdf';
import ReactToPrint from "react-to-print";
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import MaterialTable, { MTableBody } from "material-table";
import _, { flatMap } from 'lodash';
import $ from 'jquery';

const screenCode = 'EMPLOYEECHECKROLLDAYWISEMONTHLYDETAILREPORT'

export function EmployeeCheckRollDayWiseMonthlyDetailReport(props) {

    const componentRef = useRef();

    const [groups, setGroups] = useState([]);
    const [estates, setEstates] = useState([]);
    const [collectionPoint, setCollectionPoint] = useState([]);
    const [isTableHide, setIsTableHide] = useState(true);
    const [totalCollections, setTotalCollections] = useState({
        totalAmount: 0,
        extraKg: 0,
        allTotal: 0,
        firstName: "",
        registrationNumber: ""
    });
    const [searchData, setsearchData] = useState({
        groupID: "0",
        operationEntityID: "0",
        fromDate: "",
        toDate: "",
        regNumber: "",
        pluckingType: "0"

    });
    const [errors, setErrors] = useState({});
    const schema = Joi.object(EmployeeCheckRollDayWiseMonthlyDetailReportSchema).options({ allowUnknown: true });
    const [data, setdata] = useState([]);
    const [csvData, setCsvData] = useState([]);
    const DropdownChanges = Object.freeze({ "group": 1, "operationEntity": 2 })
    const [reportData, setReportData] = useState([]);
    const [isViewTable, setIsViewTable] = useState(true);
    const [columeNames, setColumeNames] = useState([]);
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });
    const inishialColumName = [{
        title: 'Date', field: 'weightReadTime', render: rowData => rowData.weightReadTime, headerStyle: {
            color: '#000000',
            textAlign: 'center',
            fontWeight: 'bold'
        }, cellStyle: { textAlign: 'left' }

    }]
    const csvHeaders = [
        { label: "Date", value: "createdDate" },
        { label: "Checkroll (Kg)", value: "totalAmount" },
        { label: "Extra (Kg)", value: "extraKg" },
        { label: "Total (Kg)", value: "totalCol" },
    ];
    const contentRowNames = ["createdDate", "totalAmount", "extraKg", "totalCol"]
    const [csvHeader, setCsvHeaders] = useState([]);
    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "",
        estate: "",
        fromDate: "",
        toDate: "",
        pluckingTy: ""
    });

    useEffect(() => {
        trackPromise(
            getPermissions()
        )
    }, [])

    useEffect(() => {
        trackPromise(
            getEstatesForDropdown()
        )
    }, [searchData.groupID])

    useEffect(() => {
        trackPromise(
            getCollectionPointsForDropDown()
        )

    }, [searchData.operationEntityID])

    useEffect(() => {
        trackPromise(
            checkDisbursement()
        )
    }, [searchData.toDate])

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWEMPLOYEECHECKROLLDAYWISEREPORT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');
        setPermissions({
            ...permissionList,

            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        var token = tokenService.getUserDetailsFromToken();
        setsearchData({
            ...searchData,
            groupID: token.groupID,
            operationEntityID: token.operationEntityID
        });

        getGroupsForDropDown();
    }

    async function getGroupsForDropDown() {
        const groupsList = await groupService.getGroupsForDropdown();
        setGroups(groupsList);
    }

    async function getCollectionPointsForDropDown() {
        const collectionPoint = await service.getCollectionPointsByOperationentityGroupID(searchData.operationEntityID, searchData.groupID);
        setCollectionPoint(collectionPoint);
    }

    async function getEstatesForDropdown() {
        const data = await service.getEstatesByGroupID(searchData.groupID);
        setEstates(data);
    }

    function handleChange(e) {
        e.preventDefault();

        const target = e.target;
        const value = target.value;

        const error = { ...errors };
        const errorMessage = validateProperty(target, EmployeeCheckRollDayWiseMonthlyDetailReportSchema);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];

        setsearchData({
            ...searchData,
            [e.target.name]: value
        });

        setErrors(error);
    }
    function handleEstateChange(target) {
        setsearchData({
            ...searchData,
            operationEntityID: target.value,
        });
    }

    async function handleSearch() {
        setIsTableHide(true);
        destroyDataTable()
        let totalAmount = 0;
        let extraKg = 0;
        let allTotal = 0;


        const reportData = await service.GetEmployeeCheckRollDayWiseMonthlyDetailReport(searchData.operationEntityID, searchData.regNumber, searchData.pluckingType, searchData.fromDate, searchData.toDate);

        for (const item of reportData) {
            totalAmount = totalAmount + item.totalAmount;
            extraKg = extraKg + item.extraKg;
            allTotal = totalAmount + extraKg;
            var firstName = item.firstName;
            var registrationNumber = item.registrationNumber;
        }
        const sumValues = [{
            createdDate: "Total",
            totalAmount: totalAmount.toFixed(2),
            extraKg: extraKg.toFixed(2)
        }];

        setTotalCollections({
            ...totalCollections,
            totalAmount: totalAmount.toFixed(2),
            extraKg: extraKg.toFixed(2),
            allTotal: allTotal.toFixed(2),
            firstName: firstName,
            registrationNumber: registrationNumber
        });

        reportData.forEach(x => {
            x.createdDate = x.createdDate.split('T')[0];
            x.totalCol = (x.totalAmount + x.extraKg)
        });

        let finalData = reportData;

        finalData.forEach(x => {
            x.totalCol = x.totalCol.toFixed(2);
            x.extraKg = x.extraKg.toFixed(2);
            x.totalAmount = x.totalAmount.toFixed(2);
        });

        setReportData(finalData)
        setCsvData(finalData)
        createDataTable()
        setCsvHeaders(csvHeaders);
        setSelectedSearchData();
        setIsTableHide(false);

    }

    function setSelectedSearchData() {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchData.groupID],
            estate: estates[searchData.operationEntityID],
            fromDate: searchData.fromDate,
            toDate: searchData.toDate,
            pluckingTy: searchData.pluckingType
        })
    }

    async function checkDisbursement() {
        if (searchData.fromDate === '' && searchData.toDate === '') {
            setIsViewTable(true);
        }
        else {
            setIsViewTable(false);
        }
    }

    function destroyDataTable() {
        $('#EmployeeCheckRollReport').DataTable().destroy();
    }

    function createDataTable() {
        $('#EmployeeCheckRollReport').DataTable();
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items
    }

    function createFile() {
        var settings = {
            sheetName: 'EmployeeCheckRollReport',
            fileName: 'Day Wise Employee Check Roll Report',
            writeOptions: {}
        }
        var copyOfCsv = _.cloneDeep(csvData)

        var newRow = {
            createdDate: "Total",
            totalAmount: totalCollections.totalAmount,
            extraKg: totalCollections.extraKg,
            totalCol: totalCollections.allTotal
        }
        copyOfCsv.push(newRow)
        var copyOfData = _.cloneDeep(copyOfCsv)
        var newRow1 = {
            createdDate: "Generated date/time : " + new Date().toLocaleString(),
            totalAmount: "Generated user : " + tokenService.getUserNameFromToken(),
            extraKg: "Group : " + groups[searchData.groupID],
            totalCol: "Estate : " + estates[searchData.operationEntityID]
        }
        copyOfData.push({}, {}, newRow1)
        var copyOfData2 = _.cloneDeep(copyOfData)
        var newRow2 = {
            createdDate: "Plucking Type : " + searchData.pluckingType,
            totalAmount: "From Date : " + searchData.fromDate,
            extraKg: "To Date : " + searchData.toDate,
            totalCol: "Reg Number : " + totalCollections.registrationNumber
        }
        copyOfData2.push(newRow2)
        xlsx(csvHeaders, copyOfData2, settings, true)
    }


    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="card">
                    <div className="card-body" id="startPoint">
                        <div className="row">
                            <PageHeader
                                title="Day Wise Employee Check Roll Monthly Detail Report"
                            />
                        </div>
                        <form>
                            <div className="form-group row">
                                <div className="col-md pb-1">
                                    <InputLabel shrink id="groupID">Group *</InputLabel>
                                    <Select
                                        fullWidth
                                        id="groupID"
                                        name="groupID"
                                        disabled={!permissionList.isGroupFilterEnabled}
                                        value={searchData.groupID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Group--</MenuItem>
                                        {generateDropDownMenu(groups)}
                                    </Select>
                                    {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                </div>
                                <div className="col-md">
                                    <InputLabel shrink id="operationEntityID">Estate *</InputLabel>
                                    <Select
                                        fullWidth
                                        id="operationEntityID"
                                        name="operationEntityID"
                                        disabled={!permissionList.isOperationEntityFilterEnabled}
                                        value={searchData.operationEntityID}
                                        onChange={(e) => handleEstateChange(e.target)}>
                                        <MenuItem value="0">--Select Estate--</MenuItem>
                                        {generateDropDownMenu(estates)}
                                    </Select>
                                    {errors["operationEntityID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["operationEntityID"]}</FormHelperText>)}
                                </div>
                                <div className="col-md">
                                    <InputLabel shrink id="regNumber">Reg Number*</InputLabel>
                                    <TextField
                                        fullWidth
                                        id="regNumber"
                                        name="regNumber"
                                        type="regNumber"
                                        onChange={(e) => handleChange(e)}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                    {errors["regNumber"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["regNumber"]}</FormHelperText>)}
                                </div>
                            </div>
                            <div className="form-group row">
                                <div className="col-md">
                                    <InputLabel shrink id="pluckingType">Plucking Type *</InputLabel>
                                    <Select
                                        id="pluckingType"
                                        select
                                        fullWidth
                                        name="pluckingType"
                                        onChange={(e) => handleChange(e)}
                                        value={searchData.pluckingType}>
                                        <MenuItem value="0">--Select Plucking Type--</MenuItem>
                                        <MenuItem value="GENERAL">General</MenuItem>
                                        <MenuItem value="RSM">RSM</MenuItem>
                                        <MenuItem value="CASH">Cash</MenuItem>
                                        <MenuItem value="KILO">Kilo</MenuItem>
                                    </Select>
                                    {errors["pluckingType"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["pluckingType"]}</FormHelperText>)}
                                </div>
                                <div className="col-md">
                                    <InputLabel shrink id="fromDate">From Date *</InputLabel>
                                    <TextField
                                        fullWidth
                                        id="fromDate"
                                        name="fromDate"
                                        type="date"
                                        onChange={(e) => handleChange(e)}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                    {errors["fromDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["fromDate"]}</FormHelperText>)}
                                </div>
                                <div className="col-md">
                                    <InputLabel shrink id="toDate">To Date *</InputLabel>
                                    <TextField
                                        fullWidth
                                        id="toDate"
                                        name="toDate"
                                        type="date"
                                        onChange={(e) => handleChange(e)}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                    {errors["toDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["toDate"]}</FormHelperText>)}
                                </div>
                            </div>
                            <div className="form-group row">
                                <div className="col-md pb-1">
                                    <input
                                        disabled={isViewTable}
                                        type="button"
                                        className="btn btn-primary"
                                        value="Generate"
                                        onClick={handleSearch}
                                    />
                                </div>
                            </div>
                            {isTableHide ? null :
                                <Grid item md={12} xs={12}>
                                    <div className="card">
                                        <div className="card-body">
                                            <p className="d-inline pr-3"><b>Emp Name : {totalCollections.firstName}</b></p>
                                            <p className="d-inline pr-3"><b>Reg Number : {totalCollections.registrationNumber}</b></p>
                                        </div>
                                    </div>
                                    <table id="EmployeeCheckRollReport">
                                        <thead>
                                            <tr>
                                                <th style={{ fontWeight: "bold", textAlign: "left" }}>Date</th>
                                                <th style={{ fontWeight: "bold", textAlign: "right" }}>Checkroll (Kg)</th>
                                                <th style={{ fontWeight: "bold", textAlign: "right" }}>Extra (Kg)</th>
                                                <th style={{ fontWeight: "bold", textAlign: "right" }}>Total (Kg)</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <DayWiseEmployeeCheckRollTable
                                                data={reportData}
                                                contentRowNames={contentRowNames}
                                                hasEdit={false}
                                            />
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <td><h6>Total</h6></td>
                                                <td style={{ textAlign: "right" }}><h6>{totalCollections.totalAmount}</h6></td>
                                                <td style={{ textAlign: "right" }}><h6>{totalCollections.extraKg}</h6></td>
                                                <td style={{ textAlign: "right" }}><h6>{totalCollections.allTotal}</h6></td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </Grid>
                            }
                        </form>
                        {
                            (reportData.length == 0 || reportData == undefined || reportData == null || reportData == []) ?
                                null : <div className="pt-3">
                                    <ReactToPrint
                                        trigger={() => <input
                                            type="button"
                                            className="btn btn-primary pull-right ml-2"
                                            value="Create PDF"
                                        />}
                                        content={() => componentRef.current}
                                        documentTitle={'Employee Check Roll Report'}
                                    />
                                    <div hidden={true}>
                                        <CreatePDF ref={componentRef} data={reportData} rowNames={contentRowNames}
                                            searchData={selectedSearchValues} totalCollections={totalCollections} columeNames={columeNames} />
                                    </div>
                                    <input
                                        type="button"
                                        className="btn btn-primary pull-right ml-2"
                                        value="Excel"
                                        onClick={createFile}
                                    />
                                </div>
                        }
                    </div>
                </div>
            </div>
        </Fragment >
    );
}



